import { getAll } from '@/api/tiers/index';
import { getAllWithTiers } from '@/api/contacts/index';
import genererCriteresRechercheClient
  from '@/services/bodac/client/criteresRecherche/genererCriteresRechercheClient';
import * as types from './clients-mutation-type';
import * as allTypes from '../mutation-type';

export function initialState(isCartographie) {
  return {
    clients: [],
    contacts: [],
    totalContacts: 0,
    totalClients: 0,
    clientCourant: null,
    criteresRecherche: genererCriteresRechercheClient(isCartographie),
    placeIntervenant: 0,
    lastPayload: {},
    lastPayloadContact: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.ADD_CLIENT](state, client) {
    state.clients.push(client);
  },
  [types.SET_CONTACT](state, contact) {
    state.contacts = contact;
  },
  [types.SET_TOTAL_CONTACTS](state, totalContacts) {
    state.totalContacts = totalContacts;
  },
  [types.SET_TOTAL_CLIENTS](state, totalClients) {
    state.totalClients = totalClients;
  },
  [types.SET_PLACE_INTERVENANT](state, placeIntervenant) {
    state.placeIntervenant = placeIntervenant;
  },
  [types.SET_CLIENT](state, clients) {
    state.clients = clients;
  },
  [types.EDIT_CLIENT](state, client) {
    const ancienClient = state.clients.find((el) => { return el.id === client.id; });
    state.clients.splice(state.clients.indexOf(ancienClient), 1, client);
  },
  [types.EDIT_CONTACT](state, contact) {
    const ancienContact = state.contacts.find((el) => { return el.id === contact.id; });
    state.contacts.splice(state.contacts.indexOf(ancienContact), 1, contact);
  },
  [types.SET_CLIENT_COURANT](state, clientCourant) {
    state.clientCourant = clientCourant;
  },
  [types.SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_LAST_PAYLOAD_CONCTAT](state, payload) {
    state.lastPayloadContact = payload;
  },
};

const actions = {
  async loadContacts({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD_CONCTAT, data);
    const response = await getAllWithTiers(data);
    response.data.result.items.forEach((contact) => {
      contact.selected = false;
    });
    commit(types.SET_TOTAL_CONTACTS, response.data.result.totalCount);
    commit(types.SET_CONTACT, response.data.result.items);
    return {};
  },
  async loadClients({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD, data);
    const response = await getAll(data);
    response.data.result.items.forEach((client) => {
      client.selected = false;
    });
    commit(types.SET_TOTAL_CLIENTS, response.data.result.totalCount);
    commit(types.SET_CLIENT, response.data.result.items);
    return {};
  },
  setClientCourant({ commit }, client) {
    commit(types.SET_CLIENT_COURANT, client);
  },
  setPlaceIntervant({ commit }, placeIntervenant) {
    commit(types.SET_PLACE_INTERVENANT, placeIntervenant);
  },
  addClient({ commit }, client) {
    commit(types.ADD_CLIENT, client);
  },
};

const getters = {
  clients: state => {
    return state.clients;
  },
  contacts: state => {
    return state.contacts;
  },
  clientCourant: state => {
    return state.clientCourant;
  },
  totalContacts: state => {
    return state.totalContacts;
  },
  totalClients: state => {
    return state.totalClients;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  placeIntervenant: state => {
    return state.placeIntervenant;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  lastPayloadContact: state => {
    return state.lastPayloadContact;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
